let Toast = {};
Toast.install  = (Vue, options) => {
  Vue.directive('numberOnly', {
    bind (el, binding) {
        el.children[0].handler = () => {
            let elInputValue = (el.children[0].value + "").replace(/[^\d]/g, '');
            if(binding.value.isString){//字符串number
                el.children[0].value = elInputValue;
                // 手动刷新data中绑定的属性
                if(binding.value.name.split(".").length == 1){
                    binding.value.set[binding.value.name] = elInputValue;
                }else if(binding.value.name.split(".").length == 2){//"postData.jobnum"
                    let keyList = binding.value.name.split(".");
                    binding.value.set[keyList[0]][keyList[1]] = elInputValue;
                }
            }else{
                el.children[0].value = elInputValue ? Number(elInputValue) : "";
                // 手动刷新data中绑定的属性
                if(binding.value.name.split(".").length == 1){
                    binding.value.set[binding.value.name] = elInputValue ? Number(elInputValue) : "";
                }else if(binding.value.name.split(".").length == 2){//"postData.jobnum"
                    let keyList = binding.value.name.split(".");
                    binding.value.set[keyList[0]][keyList[1]] = elInputValue ? Number(elInputValue) : "";
                }
            }
        }
        el.children[0].addEventListener('keyup', el.children[0].handler)
    },
    unbind (el) {
        el.children[0].removeEventListener('keyup', el.children[0].handler)
    }
  })

} 
module.exports = Toast;


// WEBPACK FOOTER //
// ./src/config/plugIn.js